import { Pipe, PipeTransform } from '@angular/core';
import { enumToText } from '../helpers/enumToText.function';

@Pipe({
  name: 'enumToString',
  standalone: false,
})
export class EnumToStringPipe implements PipeTransform {
  transform(value?: number, enumType?: any): string {
    return enumToText(enumType, value);
  }
}
